import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientInvoicesPage from "@/pages/client/ClientInvoicesPage";

export const Route = createFileRoute("/client/contracts/$contractId/invoices")({
  head: () => pageHead("Client · Contracts · Invoices", "AKIVA client · contracts · invoices portal.", "/client/contracts/$contractId/invoices", true),
  component: ClientInvoicesPage,
});
